import { connect } from 'react-redux';
import { bool, func, object, string } from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy';
import classnames from 'classnames';

import LogoNav from 'dibs-logo/exports/LogoNav';
import Notifications from '../Notifications/Notifications';
import { SearchBar } from '../SearchBar/SearchBar';
import AccountNav from '../AccountNav/AccountNav';
import Likes from '../Likes/Likes';
import CartNav from '../CartNav/CartNav';
import { OfferVisibility } from '../OfferVisibility/OfferVisibility';

import dibsCss from 'dibs-css';
import styles from './TopBar-style.scss';

const TopBarComponent = props => {
    const {
        hasRootPendingRefetch,
        hasUserId,
        hasUser,
        isClient,
        user,
        userId,
        viewer,
        onMouseOver,
        onMouseOut,
        hasError,
        isEmailOnly,
        isSticky,
        hasTradeUserId,
    } = props;
    const hasOfferVisibility = props.viewer?.offerVisibilityFF;
    const barClasses = classnames(styles.bar, dibsCss.zBump, {
        [styles.stickyBar]: isSticky,
    });

    if (hasError) {
        return (
            <div className={barClasses}>
                <div
                    className={classnames(styles.barContent, dibsCss.flex, dibsCss.justifyBetween)}
                >
                    <div
                        className={classnames(
                            dibsCss.flex,
                            dibsCss.itemsCenter,
                            dibsCss.grow,
                            dibsCss.shrink,
                            dibsCss.basis0
                        )}
                    >
                        <LogoNav />
                    </div>
                </div>
            </div>
        );
    }

    return (
        // eslint-disable-next-line jsx-a11y/mouse-events-have-key-events
        <div className={barClasses} onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
            <div
                className={classnames(
                    styles.barContent,
                    dibsCss.flex,
                    dibsCss.justifyBetween,
                    !isSticky && dibsCss.ptXsmall
                )}
                data-tn="main-nav-top"
            >
                <div
                    className={classnames(
                        dibsCss.flex,
                        dibsCss.itemsCenter,
                        dibsCss.grow,
                        dibsCss.shrink,
                        dibsCss.basis0
                    )}
                >
                    <SearchBar
                        hasClickableSearchButton
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        isClient={isClient}
                        viewer={viewer}
                    />
                </div>
                <LogoNav isStickyLogo={isSticky} />
                <div
                    className={classnames(
                        styles.rightContainer,
                        dibsCss.flex,
                        dibsCss.justifyEnd,
                        dibsCss.itemsCenter,
                        dibsCss.grow,
                        dibsCss.shrink,
                        dibsCss.basis0
                    )}
                >
                    {hasOfferVisibility ? <OfferVisibility user={user} viewer={viewer} /> : null}
                    <AccountNav
                        isClient={isClient}
                        hasUser={hasUser}
                        hasUserId={hasUserId}
                        user={user}
                        hasTradeUserId={hasTradeUserId}
                        viewer={viewer}
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasOfferVisibility={hasOfferVisibility}
                    />
                    {!isEmailOnly && (
                        <Notifications
                            hasRootPendingRefetch={hasRootPendingRefetch}
                            hasUserId={hasUserId}
                            isClient={isClient}
                            userId={userId}
                            viewer={viewer}
                            initialViewer={viewer}
                            user={user}
                        />
                    )}

                    <Likes
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasUserId={hasUserId}
                        fetchNewEvents={hasUserId && isClient && !hasRootPendingRefetch}
                        isClient={isClient}
                        userId={userId}
                        viewer={viewer}
                    />

                    <CartNav
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        hasUserId={hasUserId}
                        isClient={isClient}
                        user={user}
                        userId={userId}
                        viewer={viewer}
                    />
                </div>
            </div>
        </div>
    );
};

TopBarComponent.propTypes = {
    hasError: bool,
    hasRootPendingRefetch: bool,
    hasUser: bool,
    hasUserId: bool,
    isClient: bool,
    openDrawer: func,
    user: object,
    userId: string,
    viewer: object,
    onMouseOver: func,
    onMouseOut: func,
    isEmailOnly: bool,
    isSticky: bool,
    hasTradeUserId: bool,
};

const mapStateToProps = ({ header }) => ({
    isEmailOnly: header.isEmailOnly,
});

export const TopBar = createFragmentContainer(connect(mapStateToProps)(TopBarComponent), {
    viewer: graphql`
        fragment TopBar_viewer on Viewer {
            ...CartNav_viewer
            ...Likes_viewer
            ...Notifications_viewer
            ...Notifications_initialViewer
            ...SearchBar_viewer
            ...AccountNav_viewer
            ...OfferVisibility_viewer
            offerVisibilityFF: featureFlag(feature: "offerVisibilityIndicator")
        }
    `,

    user: graphql`
        fragment TopBar_user on User {
            ... @include(if: $isClient) {
                ...AccountNav_user
                ...CartNav_user
                ...Notifications_user
            }
        }
    `,
});
